import { Link as MaterialLink } from '@mui/material';
import { DownloadFileDto } from '@sr/dto';
import { fileLinkManager } from 'utils/link-manager';
import { ReactNode } from 'react';
import { downloadFile } from '../../../utils/download-file';

export const fileNameCutter = (name: string, length = 16): string => {
  return name.length > length ? name.slice(0, length - 3) + '...' : name;
};

export const LinkToFile = ({ file: { id, fileName }, icon, downloadUrl }: { file: DownloadFileDto, icon?: ReactNode, downloadUrl?: string }) => {
  const link = fileLinkManager.link(id);
  const handleDownload = async (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    await downloadFile(downloadUrl ?? `/api/files/private/${id}`, fileName);
  };

  return (
    <MaterialLink href={link} target="_self" onClick={handleDownload}>
      {icon}
      {fileNameCutter(fileName)}
    </MaterialLink>
  );
};
